module.exports = __webpack_public_path__ + "static/media/_scotland.db814740.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_scotland.svg
// module id = 2349
// module chunks = 7